import ShopaholicProductList from './shopaholic-product-list/shopaholic-product-list';
import ShopaholicPagination  from './shopaholic-product-list/shopaholic-pagination';
import ShopaholicFilterPanel from './shopaholic-filter-panel/shopaholic-filter-panel'
import UrlGeneration         from '@lovata/url-generation';

export default class CatalogCategory {
	constructor({
		itemsWrapper = 'market-products__grid',
		filterWrapper = 'market-filter',
		paginationLink = 'pagination__link',
		paginationPreloader = '.pagination__item--hidden',
		sortingSelect = 'market-products__sorting',
		filterGroup = '.market-filter__group',
		filterCategory = '.market-filter__category',
		filterReset = '[data-filter="reset"]'
	}) {
		this.itemsWrapper        = itemsWrapper;
		this.filterWrapper       = filterWrapper;
		this.paginationLink      = paginationLink;
		this.paginationPreloader = paginationPreloader;
		this.sortingSelect       = sortingSelect;
		this.filterGroup         = filterGroup;
		this.filterCategory      = filterCategory;
		this.filterReset         = filterReset;
		this.obList              = null;
		
		this.init();
	}
	
	init() {
		const obListHelper = new ShopaholicProductList();
		obListHelper.setAjaxRequestCallback((obRequestData) => {
			/* eslint-disable */
			obRequestData.update   = {
				'shopaholic/category/item-list':`.${this.itemsWrapper}`
			};
			obRequestData.loading  = this.paginationPreloader;
			obRequestData.complete = () => {
				this.updateAfterAjax();
			};
			/* eslint-enable */
			return obRequestData;
		});
		
		this.obList = obListHelper;
		
		this.pagination(obListHelper);
		this.filteredProperties(obListHelper);
		this.filteredCategory(obListHelper);
		this.filteredReset(obListHelper);
	}
	
	pagination(obListHelper) {
		// Pagination
		const obPaginationHelper = new ShopaholicPagination(obListHelper);
		obPaginationHelper
		.setDefaultWrapperClass(this.itemsWrapper)
		.setButtonSelectorClass(this.paginationLink)
		.init();
	}
	
	filteredProperties(obListHelper) {
		const obFilterPanel = new ShopaholicFilterPanel(obListHelper);
		obFilterPanel.setWrapperSelector(this.filterGroup).init();
	}
	
	filteredCategory(obListHelper) {
		// Filter Category
		const obCategoryFilterPanel = new ShopaholicFilterPanel(obListHelper);
		obCategoryFilterPanel
		.setWrapperSelector(this.filterCategory)
		.setFieldName('category')
		.init();
	}
	
	filteredReset(obListHelper) {
		const self        = this;
		const resetButton = document.querySelector(self.filterReset);
		if (!resetButton) {
			return;
		}
		resetButton.addEventListener('click', function (button) {
			button.preventDefault();
			const checkedCheckboxes = document.querySelector(`.${self.filterWrapper}`).querySelectorAll('input[type="checkbox"]:checked');
			checkedCheckboxes.forEach(function (checkbox) {
				checkbox.checked = false;
			});
			
			// Clear URL
			UrlGeneration.init();
			UrlGeneration.clear();
			
			// Update list
			obListHelper.send();
		});
	}
	
	updateAfterAjax() {
		// this.filteredProperties(this.obList);
		// this.filteredCategory(this.obList);
		// this.filteredReset(this.obList);
	}
}
